/*
 * @Author: wangkai 1148506760@qq.com
 * @Date: 2022-11-01 11:19:59
 * @LastEditors: wangkai 1148506760@qq.com
 * @LastEditTime: 2023-02-07 14:32:16
 * @FilePath: \HQ_pc\pc\src\api\home\home.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import request from "@/util/http";
import qs from "qs";
// 获取树形结构的节点
export function getPageDeskVo(params) {
  return request({
      url: `/admin/homeTemplate/getPageDeskVo`,
      method: "get",
      params: params,
  });
}
export function stuAndteachStastic(data) {
  return request({
      url: `/admin/homeServe/hostServe`,
      method: "get",
      headers:{
        "token":  window.sessionStorage.bpmnSid
      },
      data: data,
  });
}